/**
 * LA LETTRINE. La première lettre du nœud, gravée dans un carré hachuré.
 *
 * Elle n'est pas là pour décorer : elle dit « ici commence un texte », et c'est utile quand on
 * revient sur une aventure après trois semaines. On ne la pose que sur le PREMIER paragraphe, et
 * seulement s'il commence par une lettre — une lettrine sur un tiret de dialogue est une faute.
 */
export function Lettrine({ texte }: { texte: string }) {
  const premiere = texte.trimStart().charAt(0);
  const lettreOrnable = /\p{L}/u.test(premiere);
  if (!lettreOrnable) return <p className="noeud__texte">{texte}</p>;

  return (
    <p className="noeud__texte noeud__texte--ouverture">
      {/* Pas d'`aria-hidden` ici : la lettre appartient au mot. Cachée, un lecteur d'écran
          annoncerait « aris » pour « Paris ». */}
      <span className="lettrine">{premiere}</span>
      {texte.trimStart().slice(1)}
    </p>
  );
}
